export default __webpack_public_path__ + "static/media/logo-cgl.b670da37.svg";